export default {
  entities: "contacts/data/entities",
  people: "contacts/data/people",
  groupsDoc: "contacts/groups",
  peopleTagDoc: "contacts/peopleTags",
  positionTagDoc: "contacts/positionTags",
  entityTagDoc: "contacts/entityTags",
};
